import React from 'react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { CheckCircle2 } from 'lucide-react';
export function TicketPrices() {
  return <div className="space-y-6 max-w-4xl" data-id="element-305">
      <div data-id="element-306">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-307">
          টিকিট মূল্য সেটিংস
        </h1>
        <p className="text-slate-500" data-id="element-308">
          টিকিটের বর্তমান মূল্য এবং পূর্ববর্তী ইতিহাস
        </p>
      </div>

      {/* Current Price Card */}
      <div className="bg-gradient-to-br from-brand-coral/10 to-brand-coral/5 border border-brand-coral/20 rounded-2xl p-6 flex items-center justify-between" data-id="element-309">
        <div data-id="element-310">
          <div className="flex items-center gap-2 mb-2" data-id="element-311">
            <span className="text-sm font-medium text-slate-600" data-id="element-312">
              বর্তমান সক্রিয় মূল্য
            </span>
            <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-brand-green/10 text-brand-green" data-id="element-313">
              <CheckCircle2 className="w-3 h-3" data-id="element-314" />
              Active
            </span>
          </div>
          <div className="text-4xl font-bold text-slate-900" data-id="element-315">
            ৳২০ <span className="text-lg text-slate-500 font-normal" data-id="element-316">/ জন</span>
          </div>
          <p className="text-sm text-slate-500 mt-2" data-id="element-317">
            কার্যকরী তারিখ: ০১ জানুয়ারি ২০২৬
          </p>
        </div>
      </div>

      {/* Update Form */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-318">
        <div className="p-6 border-b border-slate-100" data-id="element-319">
          <h2 className="text-lg font-bold text-slate-900" data-id="element-320">
            নতুন মূল্য নির্ধারণ করুন
          </h2>
        </div>
        <div className="p-6" data-id="element-321">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-322">
            <div className="space-y-2" data-id="element-323">
              <label className="text-sm font-medium text-slate-700" data-id="element-324">
                টিকিটের ধরন
              </label>
              <Input defaultValue="সাধারণ প্রবেশ" disabled data-id="element-325" />
            </div>
            <div className="space-y-2" data-id="element-326">
              <label className="text-sm font-medium text-slate-700" data-id="element-327">
                নতুন মূল্য (৳)
              </label>
              <Input type="number" placeholder="যেমন: ২০" data-id="element-328" />
            </div>
            <div className="space-y-2" data-id="element-329">
              <label className="text-sm font-medium text-slate-700" data-id="element-330">
                স্ট্যাটাস
              </label>
              <select className="flex h-12 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral" data-id="element-331">
                <option data-id="element-332">Active</option>
                <option data-id="element-333">Inactive</option>
              </select>
            </div>
            <div className="space-y-2" data-id="element-334">
              <label className="text-sm font-medium text-slate-700" data-id="element-335">
                কার্যকরী তারিখ
              </label>
              <Input type="date" data-id="element-336" />
            </div>
          </div>
          <div className="mt-6 flex justify-end" data-id="element-337">
            <Button data-id="element-338">সংরক্ষণ করুন</Button>
          </div>
        </div>
      </div>

      {/* History Table */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-339">
        <div className="p-6 border-b border-slate-100" data-id="element-340">
          <h2 className="text-lg font-bold text-slate-900" data-id="element-341">
            মূল্য পরিবর্তন ইতিহাস
          </h2>
        </div>
        <div className="overflow-x-auto" data-id="element-342">
          <table className="w-full text-sm text-left" data-id="element-343">
            <thead className="text-xs text-slate-500 bg-slate-50 uppercase" data-id="element-344">
              <tr data-id="element-345">
                <th className="px-6 py-4 font-medium" data-id="element-346">মূল্য</th>
                <th className="px-6 py-4 font-medium" data-id="element-347">স্ট্যাটাস</th>
                <th className="px-6 py-4 font-medium" data-id="element-348">কার্যকরী তারিখ</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-349">
              <tr className="hover:bg-slate-50" data-id="element-350">
                <td className="px-6 py-4 font-medium text-slate-900" data-id="element-351">৳২০</td>
                <td className="px-6 py-4" data-id="element-352">
                  <span className="inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium bg-brand-green/10 text-brand-green" data-id="element-353">
                    Active
                  </span>
                </td>
                <td className="px-6 py-4 text-slate-500" data-id="element-354">০১ জানুয়ারি ২০২৬</td>
              </tr>
              <tr className="hover:bg-slate-50" data-id="element-355">
                <td className="px-6 py-4 font-medium text-slate-900" data-id="element-356">৳১০</td>
                <td className="px-6 py-4" data-id="element-357">
                  <span className="inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-600" data-id="element-358">
                    Inactive
                  </span>
                </td>
                <td className="px-6 py-4 text-slate-500" data-id="element-359">০১ জানুয়ারি ২০২৫</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}